import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

function PatternLibModalComponent({
  show = false,
  onHide = () => null,
  bsSize = 'medium',
  modalHeading = '',
  modalBody = '',
  modalFooter = '',
  closeButton = true,
  backdrop = true,
  scope = this,
  customClass,
}) {
  return (
    <div>
      {customClass === 'c-update-modal' ? (
        <Modal
          show={show}
          className={customClass}
          onHide={onHide}
          bsSize={bsSize}
          modalHeading={modalHeading}
          modalFooter={modalFooter}
          container={scope}
          backdrop={backdrop}
        >
          <Modal.Header
            className="c-update-modal__header"
            closeButton={closeButton}
          >
            <Modal.Title
              className="c-update-modal__title"
              id="contained-modal-title-lg"
            >
              {` ${modalHeading} `}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="c-update-modal__body">
            <div> {modalBody} </div>
          </Modal.Body>

          <Modal.Footer className="c-update-modal__footer">
            {modalFooter}
          </Modal.Footer>
        </Modal>
      ) : (
        <Modal
          show={show}
          className={customClass}
          onHide={onHide}
          bsSize={bsSize}
          modalHeading={modalHeading}
          modalFooter={modalFooter}
          container={scope}
          backdrop={backdrop}
        >
          <Modal.Header className="c-modal__header" closeButton={closeButton}>
            <Modal.Title
              componentClass="h2"
              className="c-modal__title"
              id="contained-modal-title-lg"
            >
              {modalHeading}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body
            className={
              modalHeading === '' && modalFooter === ''
                ? 'c-modal__body'
                : 'c-modal__body c-modal__body--padding'
            }
            data-test-id="payee_errmsg"
          >
            {modalBody}
          </Modal.Body>
          <Modal.Footer className="c-modal__footer">{modalFooter}</Modal.Footer>
        </Modal>
      )}
    </div>
  );
}

PatternLibModalComponent.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  bsSize: PropTypes.string,
  modalHeading: PropTypes.string,
  modalBody: PropTypes.string,
  modalFooter: PropTypes.string,
  customClass: PropTypes.string,
  closeButton: PropTypes.bool,
};

export default PatternLibModalComponent;
